import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { xxllncColor } from '../layout/theme/color'

export const LOG_LEVEL_CHOICES = [
  { id: 'normal', name: 'Normaal' },
  { id: 'verbose', name: 'Uitgebreid (debug)' },
]

export const LOG_METHOD_COLORS: Record<string, string> = {
  GET: xxllncColor.green100,
  POST: xxllncColor.dark100,
  PUT: xxllncColor.orange100,
  DELETE: xxllncColor.red100,
  PATCH: xxllncColor.yellow100,
  HEAD: 'rgba(0,0,0,0.45)',
  OPTIONS: 'rgba(0,0,0,0.45)',
}

export const LogBodyPreview: FC<{ preview: string }> = ({ preview }) => (
  <Box sx={{ mt: 1 }}>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
      Response body preview
    </Typography>
    <Box
      component="pre"
      sx={{
        m: 0, p: 1.5, bgcolor: '#1a1a1a', color: '#e8e8e8', borderRadius: '8px',
        fontSize: 11, fontFamily: 'monospace', overflowX: 'auto',
        maxHeight: 200, overflowY: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all',
      }}
    >
      {preview}
    </Box>
  </Box>
)
